import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import LocalizedImage from '@LocalizedImage';
import {
  HELP_SECTION_UPLOAD_ART,
  HELP_TOPIC_UPLOAD_ART,
  HELP_TOPIC_UPLOAD_ART_PREPARE_FILES,
  HELP_TOPIC_UPLOAD_ART_LABEL_SHAPE_YOUR_UPLOAD,
  HELP_SECTION_WHITE_INK,
  HELP_TOPIC_WHITE_INK_IN_YOUR_UPLOAD,
  HELP_UPLOAD_ART_LABELS,
} from '@app/constants';
import { connect } from 'react-redux';
import { showHelp } from '@app/actions/helpActions';
import { setLabelTypePart } from '@app/utils/help';
import './UploadArtSection.scss';

const UploadArtSection = ({ activeTopic, scrollToTopic, isRoll, isSheetFlow, isStickerFlow, isDesignIn, showHelp }) => {
  const labelTypePart = setLabelTypePart(HELP_UPLOAD_ART_LABELS, [isRoll, isStickerFlow, isSheetFlow]);

  useEffect(() => {
    activeTopic && scrollToTopic(activeTopic);
  }, [activeTopic, scrollToTopic]);

  return (
    <div id={HELP_SECTION_UPLOAD_ART} className="help-section">
      <div id={HELP_TOPIC_UPLOAD_ART} className="section-topic">
        <LocalizedText id={`qau-help-topic-${isDesignIn ? labelTypePart : ''}upload-art`} tagName="h2" />
        <LocalizedText id={`qau-help-topic-upload-${isDesignIn ? labelTypePart : ''}art-subtitle`} tagName="h3" />
        <div>
          <LocalizedText id={`qau-help-topic-upload-art-${labelTypePart}p1`} tagName="p" />
          <LocalizedText id="qau-help-topic-upload-art-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-upload-art-p3" tagName="p" />
          <LocalizedText id={`qau-help-topic-upload-art-${!isRoll ? labelTypePart : ''}p4`} tagName="p" />
          {!isDesignIn && <LocalizedText id={`qau-help-topic-upload-art-${labelTypePart}p5`} tagName="p" />}
        </div>
      </div>
      <div id={HELP_TOPIC_UPLOAD_ART_PREPARE_FILES} className="section-topic">
        <LocalizedText id={`qau-help-topic-upload-art-${isDesignIn ? labelTypePart : ''}prepare-files`} tagName="h3" />
        <div>
          <LocalizedText id={`qau-help-topic-upload-art-prepare-files-${labelTypePart}p1`} tagName="p" />
          <LocalizedText id={`qau-help-topic-upload-art-prepare-files-${labelTypePart}p2`} tagName="p" />
          <LocalizedText id={`qau-help-topic-upload-art-prepare-files-${labelTypePart}p3`} tagName="p" />
          {isDesignIn && (
            <div className="image-block image-transparency-label">
              <LocalizedImage name="transparency-label-example.png" alt="Transparency label example" allowDefault={true} />
            </div>
          )}
          <LocalizedText id={`qau-help-topic-upload-art-prepare-files-design-in-p5`} tagName="p" />
          <LocalizedText id={`qau-help-topic-upload-art-prepare-files-${labelTypePart}p4`} tagName="p" />
          {isRoll && <LocalizedText id={`qau-help-topic-upload-art-prepare-files-${labelTypePart}p5`} tagName="p" />}
        </div>
      </div>

      {isRoll && (
        <div className="section-topic">
          <LocalizedText id="qau-help-topic-upload-art-name-design" tagName="h3" />
          <div>
            <LocalizedText id={`qau-help-topic-upload-art-name-design-${labelTypePart}p1`} tagName="p" />
          </div>
        </div>
      )}

      {isSheetFlow && (
        <div id={HELP_TOPIC_UPLOAD_ART_LABEL_SHAPE_YOUR_UPLOAD} className="section-topic">
          <LocalizedText id="qau-help-topic-upload-label-shape" tagName="h3" />
          <div>
            <LocalizedText id="qau-help-topic-upload-label-shape-p1" tagName="p" />
            <LocalizedText id="qau-help-topic-upload-label-shape-p2" tagName="p" />
            <LocalizedText id="qau-help-topic-upload-label-shape-span1" tagName="span" />
            <span> </span>
            <span
              onClick={() => showHelp(HELP_SECTION_WHITE_INK, HELP_TOPIC_WHITE_INK_IN_YOUR_UPLOAD)}
              onKeyDown={e => e.key === 'Enter' && showHelp(HELP_SECTION_WHITE_INK, HELP_TOPIC_WHITE_INK_IN_YOUR_UPLOAD)}
              className="link"
            >
              <LocalizedText id="qau-help-topic-upload-label-shape-span2" tagName="span" />
            </span>
            <span> </span>
            <LocalizedText id="qau-help-topic-upload-label-shape-span3" tagName="span" />
          </div>
        </div>
      )}
    </div>
  );
};

UploadArtSection.propTypes = {
  scrollToTopic: PropTypes.func.isRequired,
  showHelp: PropTypes.func.isRequired,
  isRoll: PropTypes.bool.isRequired,
  isSheetFlow: PropTypes.bool.isRequired,
  isStickerFlow: PropTypes.bool.isRequired,
  isDesignIn: PropTypes.bool.isRequired,
  activeTopic: PropTypes.string,
};

export default connect(null, { showHelp })(UploadArtSection);
